import "./app.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import DentalPortal from "./components/dental-portal";
import ClaimDetail from "./components/claim-detail";
import { AuthProvider, useAuth } from "./context/auth-context";
import { useAuth0 } from "@auth0/auth0-react";

// Protected Route wrapper component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  const { isAuthenticated, isLoading } = useAuth0();
  
  // Show loading state while Auth0 is initializing
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Allow access if authenticated with either method
  if (!auth.isLoggedIn && !isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  const auth = useAuth();

  // If MFA is required, show the portal which will handle showing MFA screen
  if (auth.requiresMFA) {
    return <DentalPortal />;
  }

  return (
    <Routes>
      <Route path="/" element={<DentalPortal />} />
      <Route
        path="/claims"
        element={
          <ProtectedRoute>
            <DentalPortal defaultTab="claims" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/claims/:claimId"
        element={
          <ProtectedRoute>
            <ClaimDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/eligibility"
        element={
          <ProtectedRoute>
            <DentalPortal defaultTab="eligibility" />
          </ProtectedRoute>
        }
      />
      {/* Catch all unknown routes and redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
